/**
 * AUTO-GENERATED by tools/curriculum/generate-sql-course-split-static-aliases.ts.
 * Source: content/curriculum-restructures/sql-v1/plan.json
 * Static alias contract SHA-256: 9265e16809b9af63579b92abf4fd417bc6b4d6d7e64ded0b2bea981fe0557532
 *
 * Old sql-basics keys stay enumerable. New sql-practical keys resolve to the
 * exact same static records, never copied records.
 * Do not edit this file by hand.
 */

export interface SqlCourseSplitLessonAlias {
  lessonId: string;
  oldKey: string;
  newKey: string;
  oldCourseSlug: "sql-basics";
  newCourseSlug: "sql-practical";
  lessonSlug: string;
}

export const SQL_STATIC_ALIAS_COUNT = 24 as const;
export const SQL_STATIC_ALIAS_FINGERPRINT =
  "9265e16809b9af63579b92abf4fd417bc6b4d6d7e64ded0b2bea981fe0557532" as const;

export const SQL_COURSE_SPLIT_LESSON_ALIASES = Object.freeze([
  {
    lessonId: "fe553feb-549b-4edd-a84d-1fa67f0c44c2",
    oldKey: "sql-basics/ddl-dml-alter-table",
    newKey: "sql-practical/ddl-dml-alter-table",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-alter-table",
  },
  {
    lessonId: "873ec78c-ebcd-4ad0-ac84-4357a995c771",
    oldKey: "sql-basics/ddl-dml-constraints",
    newKey: "sql-practical/ddl-dml-constraints",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-constraints",
  },
  {
    lessonId: "bdf432ea-adb1-4ab3-97b7-b11e2f46d25c",
    oldKey: "sql-basics/ddl-dml-create-database-table",
    newKey: "sql-practical/ddl-dml-create-database-table",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-create-database-table",
  },
  {
    lessonId: "2e3d9019-194d-495a-8da9-88858b57c9a1",
    oldKey: "sql-basics/ddl-dml-data-types",
    newKey: "sql-practical/ddl-dml-data-types",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-data-types",
  },
  {
    lessonId: "c16bd276-85c0-438b-bf13-28ed2838c207",
    oldKey: "sql-basics/ddl-dml-ddl-dml-quiz",
    newKey: "sql-practical/ddl-dml-ddl-dml-quiz",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-ddl-dml-quiz",
  },
  {
    lessonId: "8a11033e-0965-49cf-8e30-83ef6caeb2df",
    oldKey: "sql-basics/ddl-dml-delete-statement",
    newKey: "sql-practical/ddl-dml-delete-statement",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-delete-statement",
  },
  {
    lessonId: "9c99f4cd-a8b2-419c-93ff-faf567918c87",
    oldKey: "sql-basics/ddl-dml-hard-soft-delete",
    newKey: "sql-practical/ddl-dml-hard-soft-delete",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-hard-soft-delete",
  },
  {
    lessonId: "1c033ec8-d613-44f2-86b6-9fd9760bd487",
    oldKey: "sql-basics/ddl-dml-insert-statement",
    newKey: "sql-practical/ddl-dml-insert-statement",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-insert-statement",
  },
  {
    lessonId: "2e4228a8-8177-4687-bdf0-6f637350e02a",
    oldKey: "sql-basics/ddl-dml-truncate-drop",
    newKey: "sql-practical/ddl-dml-truncate-drop",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-truncate-drop",
  },
  {
    lessonId: "255fd066-f201-4eed-8085-d57493b021eb",
    oldKey: "sql-basics/ddl-dml-update-statement",
    newKey: "sql-practical/ddl-dml-update-statement",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "ddl-dml-update-statement",
  },
  {
    lessonId: "83256453-4add-4f3b-b21b-44ba0f396bb6",
    oldKey: "sql-basics/subqueries-cte-with",
    newKey: "sql-practical/subqueries-cte-with",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-cte-with",
  },
  {
    lessonId: "3d2a88e8-a1c2-4d2c-97ec-ab2199255310",
    oldKey: "sql-basics/subqueries-subquery-from",
    newKey: "sql-practical/subqueries-subquery-from",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-subquery-from",
  },
  {
    lessonId: "294d2b6c-3f54-4193-b0e2-26c570c9ff93",
    oldKey: "sql-basics/subqueries-subquery-quiz",
    newKey: "sql-practical/subqueries-subquery-quiz",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-subquery-quiz",
  },
  {
    lessonId: "271f8143-50f7-420e-a7f0-fa59a4b5f414",
    oldKey: "sql-basics/subqueries-subquery-select",
    newKey: "sql-practical/subqueries-subquery-select",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-subquery-select",
  },
  {
    lessonId: "1274c033-4cc4-4ad3-8611-eb357eadb490",
    oldKey: "sql-basics/subqueries-subquery-where",
    newKey: "sql-practical/subqueries-subquery-where",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-subquery-where",
  },
  {
    lessonId: "39923406-360f-4ccd-a15f-1c9c666a4f8d",
    oldKey: "sql-basics/subqueries-what-is-subquery",
    newKey: "sql-practical/subqueries-what-is-subquery",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "subqueries-what-is-subquery",
  },
  {
    lessonId: "affff86b-8d4c-4bc6-b124-8df0ef34b121",
    oldKey: "sql-basics/table-joins-inner-join",
    newKey: "sql-practical/table-joins-inner-join",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-inner-join",
  },
  {
    lessonId: "e2d37377-88b8-4603-80c2-5a62857b73bc",
    oldKey: "sql-basics/table-joins-join-practice",
    newKey: "sql-practical/table-joins-join-practice",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-join-practice",
  },
  {
    lessonId: "d31f4a1f-e8a3-43c9-aad0-ca0cf3535792",
    oldKey: "sql-basics/table-joins-join-quiz",
    newKey: "sql-practical/table-joins-join-quiz",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-join-quiz",
  },
  {
    lessonId: "fa6e19f0-34b6-40db-b22d-3972d64390fb",
    oldKey: "sql-basics/table-joins-multi-table-join",
    newKey: "sql-practical/table-joins-multi-table-join",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-multi-table-join",
  },
  {
    lessonId: "38cbc56b-68fa-4db4-aef1-cf7f488a4e8a",
    oldKey: "sql-basics/table-joins-outer-join",
    newKey: "sql-practical/table-joins-outer-join",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-outer-join",
  },
  {
    lessonId: "d56b1164-0252-4b50-88a0-39e60a256776",
    oldKey: "sql-basics/table-joins-self-join",
    newKey: "sql-practical/table-joins-self-join",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-self-join",
  },
  {
    lessonId: "0fa5777e-c69f-49cf-b06d-f0e28fb53f66",
    oldKey: "sql-basics/table-joins-set-operations",
    newKey: "sql-practical/table-joins-set-operations",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-set-operations",
  },
  {
    lessonId: "dc1195ee-27ae-42a5-8531-239a408a7cd3",
    oldKey: "sql-basics/table-joins-why-join",
    newKey: "sql-practical/table-joins-why-join",
    oldCourseSlug: "sql-basics",
    newCourseSlug: "sql-practical",
    lessonSlug: "table-joins-why-join",
  },
]) satisfies readonly SqlCourseSplitLessonAlias[];

export const SQL_OLD_TO_NEW_LESSON_KEY: Readonly<Record<string, string>> =
  Object.freeze(
    Object.fromEntries(
      SQL_COURSE_SPLIT_LESSON_ALIASES.map(({ oldKey, newKey }) => [oldKey, newKey]),
    ),
  );

export const SQL_NEW_TO_OLD_LESSON_KEY: Readonly<Record<string, string>> =
  Object.freeze(
    Object.fromEntries(
      SQL_COURSE_SPLIT_LESSON_ALIASES.map(({ oldKey, newKey }) => [newKey, oldKey]),
    ),
  );

export const SQL_TARGET_COURSE_TITLES: Readonly<Record<string, string>> =
  Object.freeze({
  "db-design-basics": "DB設計入門 ER図・正規化・インデックス",
  "dojo-sql": "SQL道場 図書館DBに挑む10問",
  "sql-basics": "SQL入門：検索・絞り込み・集計",
  "sql-practical": "SQL実践：JOIN・サブクエリ・データ更新",
  });

export const SQL_TARGET_COURSE_SHORT_TITLES: Readonly<Record<string, string>> =
  Object.freeze({
  "db-design-basics": "DB設計入門",
  "dojo-sql": "SQL道場",
  "sql-basics": "SQL入門",
  "sql-practical": "SQL実践",
  });

export function canonicalSqlLessonKey(key: string): string {
  return SQL_NEW_TO_OLD_LESSON_KEY[key] ?? key;
}

export function sqlLessonKeyAliases(key: string): readonly string[] {
  const canonical = canonicalSqlLessonKey(key);
  const next = SQL_OLD_TO_NEW_LESSON_KEY[canonical];
  return next ? [canonical, next] : [canonical];
}
